import * as React from 'react'
import * as ReactRouter from 'react-router-dom'

import * as Common from '@rushplay/common'
import * as Herz from '@rushplay/herz'

import { NavigationLink, PageNavigation } from '../page-navigation'

import { FaqPage } from './faq-page'

const navigationItems = [
  {
    label: 'faq.nav.account',
    to: '/faq/account',
  },
  {
    label: 'faq.nav.bonuses',
    to: '/faq/bonuses',
  },
  {
    label: 'faq.nav.license-security',
    to: '/faq/license-security',
  },
  {
    label: 'faq.nav.mobile',
    to: '/faq/mobile',
  },
  {
    label: 'faq.nav.payments',
    to: '/faq/payments',
  },
  {
    label: 'faq.nav.responsible-gaming',
    to: '/faq/responsible-gaming',
  },
  {
    label: 'faq.nav.technical-issues',
    to: '/faq/technical-issues',
  },
]

export function Faq() {
  const translate = Herz.I18n.useTranslate()

  return (
    <Common.Box
      flexGrow="1"
      maxWidth={['100vw', '100%']}
      pt={[1, 2]}
      display={[null, 'flex']}
      flexDirection={[null, 'column']}
    >
      <Common.Box>
        <PageNavigation header={translate('faq')}>
          {navigationItems.map(item => (
            <NavigationLink key={item.to} to={item.to}>
              {translate(item.label) && translate(item.label)}
            </NavigationLink>
          ))}
        </PageNavigation>
      </Common.Box>
      <ReactRouter.Switch>
        <ReactRouter.Redirect exact from="/faq" to="faq/account" />
        <ReactRouter.Route
          path={[
            '/faq/(account)',
            '/faq/(bonuses)',
            '/faq/(license-security)',
            '/faq/(mobile)',
            '/faq/(payments)',
            '/faq/(responsible-gaming)',
            '/faq/(technical-issues)',
            '/faq/(sports)',
          ]}
          component={FaqPage}
        />
      </ReactRouter.Switch>
    </Common.Box>
  )
}

Herz.I18n.Loader.preload(
  [
    'faq.nav.account',
    'faq.nav.bonuses',
    'faq.nav.license-security',
    'faq.nav.mobile',
    'faq.nav.payments',
    'faq.nav.responsible-gaming',
    'faq.nav.technical-issues',
    'faq',
  ],
  Faq
)

export default Faq
